import { Box, Button, Grid } from '@material-ui/core';
import React from 'react';

const buttonStyles = { borderRadius: 20, width: 190, height: 40 };

const SaveBox = ({
  onSave,
  onCancel,
  onCancelStyles,
  onSaveColor,
  onSaveStyles,
  onInactivate,
  firstButtonLabel = 'VOLTAR',
  middleButtonLabel = 'SALVAR',
  lastButtonLabel,
  onClickLastButton,
  firstButtonDisabled = false,
  middleButtonDisabled = false,
  lastButtonDisabled = false,
  removeSpacing,
}) => {
  return (
    <Box mt={removeSpacing ? 2 : 8} mb={2}>
      <Grid component={Box} p={4} bgcolor="rgba(0, 0, 0, 0.05)" item xs={12} container>
        <Grid item xs={12} sm={4}>
          <Button
            disabled={firstButtonDisabled}
            onClick={onCancel}
            style={{ ...buttonStyles, ...onCancelStyles }}
          >
            {firstButtonLabel}
          </Button>
        </Grid>
        <Grid item xs={12} sm={4} component={Box} display="flex" justifyContent="center">
          {Boolean(middleButtonLabel) && (
            <Button
              disabled={middleButtonDisabled}
              onClick={onSave}
              disableElevation
              color={onSaveColor || 'primary'}
              variant="contained"
              style={{ ...buttonStyles, ...onSaveStyles }}
            >
              {middleButtonLabel}
            </Button>
          )}
        </Grid>

        <Grid
          onClick={onInactivate}
          item
          xs={12}
          sm={4}
          component={Box}
          display="flex"
          justifyContent="flex-end"
        >
          {Boolean(lastButtonLabel) && (
            <Button
              disabled={lastButtonDisabled}
              color="secondary"
              variant="outlined"
              style={buttonStyles}
              onClick={onClickLastButton}
            >
              {lastButtonLabel}
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SaveBox;
